import { render, staticRenderFns } from "./donorProfile.vue?vue&type=template&id=dbce68e2&scoped=true"
import script from "./donorProfile.vue?vue&type=script&lang=js"
export * from "./donorProfile.vue?vue&type=script&lang=js"
import style0 from "./donorProfile.vue?vue&type=style&index=0&id=dbce68e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbce68e2",
  null
  
)

export default component.exports